import React from "react";
import { MockPage, StatCards, DataTable, GhostButton } from "@/components/mock/MockKit";

const STATS = [
  { label: "Members", value: "8" },
  { label: "Admins", value: "2" },
  { label: "Pending Invites", value: "1", tone: "amber" },
];
const COLS = [
  { key: "name", label: "Name" }, { key: "email", label: "Email" },
  { key: "role", label: "Role" }, { key: "active", label: "Last Active", mono: true },
  { key: "status", label: "Status", align: "right" },
];
const ROWS = [
  { name: "Rahul Dewan", email: "rahuldewan@ehiehr.com", role: "Primary admin", active: "Just now", status: { pill: { label: "Active", tone: "green" } } },
  { name: "Samuel Ortiz", email: "samuel@ehiehr.com", role: "Biller", active: "2h ago", status: { pill: { label: "Active", tone: "green" } } },
  { name: "Priya Anand", email: "priya@ehiehr.com", role: "Coder", active: "Yesterday", status: { pill: { label: "Active", tone: "green" } } },
  { name: "Marcus Lee", email: "marcus@ehiehr.com", role: "Front office", active: "3d ago", status: { pill: { label: "Active", tone: "green" } } },
  { name: "new.hire@ehiehr.com", email: "new.hire@ehiehr.com", role: "Biller", active: "—", status: { pill: { label: "Invite pending", tone: "amber" } } },
];

export default function Team() {
  return (
    <MockPage id="team" title="Team" subtitle="Manage sub-logins, roles and permissions."
      actions={<GhostButton>Invite member</GhostButton>}>
      <StatCards items={STATS} />
      <DataTable columns={COLS} rows={ROWS} testid="team-table" />
    </MockPage>
  );
}
